// CalendarPreview.js
import React, { useState } from "react";
import Calendar from "react-calendar";
import { Container, Row, Col, Card, Modal, Button } from "react-bootstrap";
import "react-calendar/dist/Calendar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";
import { FaPlus } from "react-icons/fa"; // Import the Plus icon

const CalendarPreview = ({ timeslots }) => {
  const { t } = useTranslation();
  const renderTimeslots = ({ date, view }) => {
    if (view !== "month") return null;

    const day = date.toLocaleDateString("en-US", { weekday: "long" });
    const dayTimeslots = timeslots[day];

    if (!dayTimeslots || dayTimeslots.length === 0) return null;

    //Split timeslots into two groups: above and below
    const midIndex = Math.ceil(dayTimeslots.length / 2);
    const timeslotsAbove = dayTimeslots.slice(0, midIndex);
    const timeslotsBelow = dayTimeslots.slice(midIndex);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
      <>
        <div className="timeslot-con">
          <FaPlus
            className="plus-icon position-absolute"
            onClick={handleShow}
            style={{ top: "5px", right: "5px", cursor: "pointer" }}
          />
        </div>

        <Modal
          show={show}
          onHide={handleClose}
          className="modal-time-slot-card"
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="timeslot-container">
              <div className="timeslots-above">
                {timeslotsAbove.map((slot, index) => (
                  <Card key={index} className="timeslot-card">
                    <Card.Body className="p-1">
                      <div className="timeslot-time">
                        {slot.startTime} - {slot.endTime}
                      </div>
                    </Card.Body>
                  </Card>
                ))}
              </div>
              <div className="timeslots-below">
                {timeslotsBelow.map((slot, index) => (
                  <Card key={index} className="timeslot-card">
                    <Card.Body className="p-1">
                      <div className="timeslot-time">
                        {slot.startTime} - {slot.endTime}
                      </div>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  };

  return (
    <div className="time-slot-task pt-0">
      <h3>{t(`Timeslot Booking.Interview Schedule`)}</h3>
      <Calendar
        tileContent={renderTimeslots}
        locale={localStorage.getItem("i18nextLng") || "en"}
        className="full-width-calendar"
      />
    </div>
  );
};

export default CalendarPreview;
